
import { Box, Typography, Grid, Paper, Container, Avatar } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const About = () => {
  const features = [
    'Expert insurance agent and financial advisor',
    'Specialized in term plans, ULIP, and pension plans',
    'Comprehensive protection plans and savings plans',
    'Professional financial planning services',
    'Tata AIA authorized insurance agent',
    'Quick and hassle-free policy processing'
  ];

  return (
    <Box>
      <Box sx={{ 
        bgcolor: 'primary.main', 
        color: 'white',
        py: 6,
        mb: 6,
        borderRadius: 3,
        background: (theme) => theme.palette.mode === 'dark' 
          ? 'linear-gradient(135deg, #424242 0%, #212121 100%)'
          : 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
        textAlign: 'center'
      }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" sx={{ fontWeight: 700, mb: 2 }}>
            Expert Insurance Agent & Financial Advisor
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto' }}>
            Your trusted partner for comprehensive financial planning and insurance solutions
          </Typography>
        </Container>
      </Box>
      <Grid container spacing={6} alignItems="center">
        {/* Agent Photo Section */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 0 } }}>
            <Avatar
              sx={{
                width: { xs: 150, md: 200 },
                height: { xs: 150, md: 200 },
                mx: 'auto',
                mb: 2,
                border: '4px solid',
                borderColor: 'primary.main',
                boxShadow: 4,
                bgcolor: 'primary.main',
                fontSize: { xs: '3rem', md: '4rem' },
                fontWeight: 700
              }}
            >
              AT
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
              Aswani
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Certified Insurance Agent & Financial Advisor
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 2 }}>
              <Typography variant="caption" sx={{ bgcolor: 'success.main', color: 'white', px: 2, py: 0.5, borderRadius: 1 }}>
                ✅ Tata AIA Certified
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              10+ Years Experience | 500+ Happy Clients
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Typography 
            variant="h4" 
            component="h2" 
            gutterBottom
            sx={{
              position: 'relative',
              display: 'inline-block',
              '&:after': {
                content: '""',
                position: 'absolute',
                width: '60px',
                height: '4px',
                bgcolor: 'primary.main',
                bottom: '-10px',
                left: 0,
                borderRadius: 2
              }
            }}
          >
            About PolicyTap
          </Typography>

          <Typography variant="body1" paragraph color="text.primary">
            <Box component="span" fontWeight="bold" color="text.primary">PolicyTap</Box> is your trusted{' '}
            <Box component="span" fontWeight="bold" color="primary.main">insurance agent and financial advisor in Secunderabad</Box>, specializing in{' '}
            <Box component="span" fontWeight="bold" color="text.primary">term plans, ULIP, pension plans, protection plans, savings plans, and comprehensive financial planning.</Box>
          </Typography>

          <Typography variant="body1" paragraph color="text.primary">
            As a certified{' '}
            <Box component="span" fontWeight="bold" color="primary.main">
              insurance agent and financial advisor
            </Box>{' '}
            , we provide expert guidance on{' '}
            <Box component="span" fontWeight="bold" color="text.primary">
              term life insurance, ULIP (Unit Linked Insurance Plans), pension plans, protection plans, and savings plans
            </Box>{' '}
            to help you secure your family's future and achieve your financial goals.
          </Typography>

          <Typography variant="body1" paragraph color="text.primary">
            Our mission is to make{' '}
            <Box component="span" fontWeight="bold" color="primary.main">
              insurance and financial planning accessible, transparent, and easy to understand
            </Box>{' '}
            for everyone. With our expertise in{' '}
            <Box component="span" fontWeight="bold" color="text.primary">
              Tata AIA insurance policies
            </Box>{' '}
            and comprehensive{' '}
            <Box component="span" fontWeight="bold" color="text.primary">
              financial planning services
            </Box>
            , we help you make informed decisions about your insurance and investment needs.
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <Paper 
            elevation={3} 
            sx={{ 
              p: { xs: 3, md: 4 }, 
              height: '100%',
              borderRadius: 3,
              bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'hidden',
              '&:before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '6px',
                background: (theme) => theme.palette.mode === 'dark'
                  ? 'linear-gradient(90deg, #90caf9 0%, #64b5f6 100%)'
                  : 'linear-gradient(90deg, #1976d2 0%, #0d47a1 100%)',
              }
            }}
          >
            <Typography 
              variant="h5" 
              component="h3" 
              gutterBottom
              sx={{ 
                fontWeight: 700,
                mb: 3,
                color: 'primary.main'
              }}
            >
              Why Choose PolicyTap?
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {features.map((feature, index) => (
                <Box 
                  key={index} 
                  component="li" 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'flex-start',
                    mb: 2,
                    transition: 'all 0.3s',
                    p: 1.5,
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: (theme) => theme.palette.mode === 'dark' 
                        ? 'rgba(144, 202, 249, 0.08)' 
                        : 'rgba(25, 118, 210, 0.05)',
                      transform: 'translateX(4px)'
                    }
                  }}
                >
                  <CheckCircleIcon 
                    color="primary" 
                    sx={{ 
                      mr: 2, 
                      mt: '2px',
                      flexShrink: 0
                    }} 
                  />
                  <Typography variant="body1" color="text.primary">
                    {feature}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Enhanced Trust Signals & Certifications */}
            <Box sx={{ mt: 4, pt: 4, borderTop: '2px solid', borderColor: 'primary.main', borderRadius: '2px 2px 0 0' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, color: 'primary.main', textAlign: 'center' }}>
                🏆 Certifications & Trust Signals
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                  <Box sx={{ 
                    textAlign: 'center', 
                    p: 2, 
                    borderRadius: 2, 
                    bgcolor: 'success.light',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': { transform: 'scale(1.05)' }
                  }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      ✅
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }}>
                      Tata AIA
                    </Typography>
                    <Typography variant="caption">
                      Authorized
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Box sx={{ 
                    textAlign: 'center', 
                    p: 2, 
                    borderRadius: 2, 
                    bgcolor: 'primary.main',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': { transform: 'scale(1.05)' }
                  }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      🔒
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }}>
                      SSL A+
                    </Typography>
                    <Typography variant="caption">
                      Secured
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Box sx={{ 
                    textAlign: 'center', 
                    p: 2, 
                    borderRadius: 2, 
                    bgcolor: 'warning.main',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': { transform: 'scale(1.05)' }
                  }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      🛡️
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }}>
                      Rate
                    </Typography>
                    <Typography variant="caption">
                      Protected
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Box sx={{ 
                    textAlign: 'center', 
                    p: 2, 
                    borderRadius: 2, 
                    bgcolor: 'info.main',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': { transform: 'scale(1.05)' }
                  }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                      📋
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }}>
                      GDPR
                    </Typography>
                    <Typography variant="caption">
                      Compliant
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              
              {/* Google Reviews & Ratings */}
              <Box sx={{ 
                mt: 3, 
                textAlign: 'center', 
                p: 3, 
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100', 
                borderRadius: 2 
              }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                  ⭐ Customer Reviews
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'success.main' }}>
                      4.9/5
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Google Reviews
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'success.main' }}>
                      500+
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Happy Clients
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'success.main' }}>
                      5+
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Years Experience
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;
